import { render, staticRenderFns } from "./PaymentCompanyDialog.vue?vue&type=template&id=210b13b7&scoped=true&"
import script from "./PaymentCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentCompanyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompanyDialog.vue?vue&type=style&index=0&id=210b13b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b13b7",
  null
  
)

export default component.exports